import React, { useState } from 'react'
import { Table, TableComponent } from 'components/Table'

export default function DatosGenerales() {
  const [TableData] = useState(
    Table.Data([
      Table.Field('idpropietario', 'Propietario'),
      Table.Field('compania', 'Compañía'),
      Table.Field('comercial', 'Nombre comercial'),
      Table.Field('gerente', 'Gerente'),
    ], [
      ...Table.DefaultActions(),
    ],
      Table.Config('spec', 'compania', 'idpropietario')
    )
  )
  
  return (
    <div>
      <h2>Datos generales</h2>
      <TableComponent
        data={TableData}
      />
    </div>
  )
}
